import React from 'react'

import { Button } from '@graftcode/design-system'

import { ACADEMY_NAV_SECTIONS } from '../../const/academyNavSections.const'
import type { MobileNavigationState } from '../../hooks/useMobileNavigation'
import type { TutorialSection } from '../../types'
import { QuickStartList } from '../QuickStartList'

import styles from '../../../../MobileMenu.module.scss'

const QUICK_START_ITEM = ACADEMY_NAV_SECTIONS.flatMap((section) => section.items).find(
  (item) => item.id === 'quickStart'
)

type QuickStartGroupProps = {
  nav: MobileNavigationState
  tutorialSections: TutorialSection[]
  currentTutorialPath?: string
}

export function QuickStartGroup({ nav, currentTutorialPath }: QuickStartGroupProps) {
  if (!QUICK_START_ITEM) return null
  if (!nav.isQuickStartPage && nav.isSubpage) return null

  return (
    <div className={styles.academySectionGroup}>
      {!nav.isQuickStartPage && (
        <Button
          variant="ghost"
          size="l"
          fullWidth
          icon={QUICK_START_ITEM.icon}
          text={QUICK_START_ITEM.label}
          onClick={() => nav.handleNavigationClick(QUICK_START_ITEM.path)}
          className={styles.academyMainNavItem}
        />
      )}

      {nav.isQuickStartPage && nav.hasQuickStartItems && (
        <>
          <div className={styles.academySectionHeader}>
            <span className={styles.academySectionHeaderLabel}>{QUICK_START_ITEM.label}</span>
          </div>
          <div className={styles.academySectionChildren}>
            <QuickStartList
              sections={nav.quickStartSectionsToShow}
              currentTutorialPath={currentTutorialPath}
              onSectionClick={nav.handleSectionClick}
            />
          </div>
        </>
      )}
    </div>
  )
}
